import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetDocumentResponseBody,
  IApiGetDocumentsRequestBody,
  IApiGetDocumentsResponseBody,
} from './DocumentsApi.types';

export class DocumentsApi {
  public constructor(private client: ApiClient) {}

  public async get(
    appId: string | undefined,
    documentId: string,
  ): Promise<IApiGetDocumentResponseBody> {
    const request: IApiJsonRequest = {
      path: `/documents/${documentId}`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetDocumentResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async getAll(
    appId: string,
    body: IApiGetDocumentsRequestBody,
  ): Promise<IApiGetDocumentsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/documents',
      method: 'get',
      params: body,
    };

    const response = await this.client.fetchJson<IApiGetDocumentsResponseBody>(
      request,
      {
        appId,
      },
    );

    return response.body;
  }
}
